// extracted by mini-css-extract-plugin
module.exports = {"customSwiperWrapper":"styles-module--custom-swiper-wrapper--31m-F","fadeIn":"styles-module--fadeIn--2vpqx","slideInDown":"styles-module--slideInDown--261gj"};